export default __webpack_public_path__ + "static/media/About 6e9d20bedecb4ec9935555261e276080.27165421.md";